import MaskedInput from "react-text-mask"

export default function Telefone(props) {
    const { inputRef, ...other } = props

    const mask = (() => {
        switch (props.codigoPais) {
            case "+54":
                return [
                    9,
                    " ",
                    /\d/,
                    /\d/,
                    /\d/,
                    " ",
                    /\d/,
                    /\d/,
                    /\d/,
                    " ",
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                ]
            case "+55":
            default:
                return [
                    "(",
                    /[1-9]/,
                    /\d/,
                    ")",
                    " ",
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    "-",
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                ]
        }
    })()

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null)
            }}
            mask={mask}
            placeholderChar={"\u2000"}
            // showMask
        />
    )
}
